/**
 * @function ContactComponent
 * @description A React component to render a Hubspot Contact Form. It utilizes the `HubspotForm` library to create a contact form with specific styling.
 * @example
 *   <ContactComponent />
 * @returns {ReactElement} Returns the Hubspot Contact Form wrapped in a styled div with pre-defined properties like portalId and formId.
 */
// import HubspotForm from 'react-hubspot-form';
export default function ContactComponent() {
  return (
    <>
      <div className="mx-auto p-5 border-gray-80 border bg-gray-60 rounded-xl flex flex-col pt-8 px-8 pb-4 xs:px-4 contact-form">
        <iframe
          className="transparent-iframe"
          allowTransparency="true"
          src="https://cloud.mkt-ellibrero.com/Contacto_El_Librero_2023_copia"
          allowFullScreen
        />
        {/* <HubspotForm
          portalId="6438710"
          formId="801c6795-1cd9-45db-a351-fe0f4e94bb05"
          onSubmit={() => console.log('Enviar!')}
          onReady={(form) => console.log('Form ready!')}
          loading={<div>Loading...</div>}
        /> */}
      </div>
    </>
  );
}
